import { settingsApiRequest } from '../../screens/settings/settingsApi';

const handler = async (args, { rejectWithValue }) => {
  try {
    const data = await settingsApiRequest({ method: 'GET', path: '/settings/articles' });
    if (process.env.NODE_ENV !== 'production') {
      console.log('services.articles.getArticles@handler', 'fetched:', data?.articles?.length);
    }
    return { articles: data.articles || [] };
  } catch (error) {
    console.error('services.articles.getArticles@handler', error);
    return rejectWithValue(error.message || error);
  }
};

const pending = (state) => ({ ...state, loading: true });
const fulfilled = (state, action) => ({
  ...state,
  loading: false,
  lists: action.payload.articles,
  initialized: true,
});
const rejected = (state) => ({ ...state, loading: false });

export default { handler, pending, fulfilled, rejected };
